<template>
  <div class="mx-3 multiple-complex">
    <strong class="d-block my-3 py-2">{{ question.text }}</strong>
    <div
      v-for="item of question.items"
      :key="item.id"
      class="mb-3 px-2"
    >
      <div class="d-block text-secondary p-2">{{ item.label }}</div>
      <div class="row no-gutters align-items-center svg-upper svg-sm">
        <label
          class="form-check p-3 mx-2 form-check-label pointer col text-center uppercase smaller shadow-sm"
          :class="{
            'text-success': answers[item.id] !== answer.id && answer.id === 'yes',
            'text-danger': answers[item.id] !== answer.id && answer.id === 'no',
            'text-secondary': answers[item.id] !== answer.id && answer.id === 'unknown',
            'bg-success text-white': answers[item.id] === answer.id && answer.id === 'yes',
            'bg-danger text-white': answers[item.id] === answer.id && answer.id === 'no',
            'bg-secondary text-white': answers[item.id] === answer.id && answer.id === 'unknown',
            'active': answers[item.id] === answer.id
          }"
          v-for="answer of question.answer_options"
          :key="answer.id"
          @click.prevent="select(item.id, answer.id)"
        >
          <div>
            <components :is="`${answer.id}-icon`"></components>
          </div>
          {{ answer.label }}
        </label>
      </div>
    </div>
    <button
      type="button"
      @click.stop="submit"
      class="btn float-right btn-primary my-3"
    >
      {{ $t('next') }} <i><unknown-icon></unknown-icon></i>
    </button>
  </div>
</template>
<script>
import UnknownIcon from '@/components/Icons/DoubleArrow'
import YesIcon from '@/components/Icons/Yes'
import NoIcon from '@/components/Icons/No'
export default {
  components: {
    YesIcon,
    NoIcon,
    UnknownIcon
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    nextCallback: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      answers: {}
    }
  },
  methods: {
    submit () {
      const answers = []
      for (const key in this.answers) {
        answers.push(`${key}:${this.answers[key]}`)
      }
      this.nextCallback(answers)
    },
    select (key, val) {
      this.$set(this.answers, key, val)
    }
  }
}
</script>
<style lang="scss">
.multiple-complex {
  .form-check {
    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.2s;
    // &:hover {
    //   box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    // }
    // &.active {
    //   box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    // }
  }
}
</style>
<i18n>
{
  "ka": {
    "next": "განაგრძე"
  },
  "en": {
    "next": "Next"
  }
}
</i18n>
